import type { IconProps } from './IconProps';

export function SettingsIcon({ className }: IconProps) {
  return (
    <svg className={className} width="1em" height="1em" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
      aria-hidden="true" focusable="false">
      <path d="M4 7h16M4 17h16" />
      <circle cx="9" cy="7" r="3" fill="var(--color-festive-card)" />
      <circle cx="15" cy="17" r="3" fill="var(--color-festive-card)" />
    </svg>
  );
}
